import querystring from 'querystring';

export async function fetchFontData(family?: string | string[]) {
  const query = querystring.stringify({
    family,
  });

  // FIXME (@resir014): allow custom base URL for fonts API
  const url = `/api/fonts?${query}`;
  const response = await fetch(url);
  return response;
}
